<script>
    export let classNames = "";
</script>

<div class="hr {classNames}"></div>

<style>
    div.hr {
        height: 1px;
        background-color: #c6c6c6;
        width: 100%;
        margin: 8px auto;
    }
    div.hr.light {
        background-color: #e6e6e6;
    }
</style>
